export class ConciliacaoBancaria {}
